export const mockRiskCommodityThresholdData = [
  {
    commodity: "Avocado",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "1.99",
    mediumRiskMin: "3.00",
    mediumRiskMax: "7.99",
    lowRiskMin: "9.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Cocoa",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "1.99",
    mediumRiskMin: "2.00",
    mediumRiskMax: "8.99",
    lowRiskMin: "9.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Coffee",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "3.49",
    mediumRiskMin: "3.50",
    mediumRiskMax: "6.99",
    lowRiskMin: "7.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Corn",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "2.49",
    mediumRiskMin: "2.50",
    mediumRiskMax: "7.49",
    lowRiskMin: "7.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Wheat",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "4.99",
    mediumRiskMin: "5.00",
    mediumRiskMax: "8.99",
    lowRiskMin: "9.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Soybeans",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "2.99",
    mediumRiskMin: "3.00",
    mediumRiskMax: "7.99",
    lowRiskMin: "8.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Rice",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "3.99",
    mediumRiskMin: "4.00",
    mediumRiskMax: "7.49",
    lowRiskMin: "7.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Sugar",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "2.49",
    mediumRiskMin: "2.50",
    mediumRiskMax: "7.49",
    lowRiskMin: "7.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Cotton",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "4.49",
    mediumRiskMin: "4.50",
    mediumRiskMax: "8.49",
    lowRiskMin: "8.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Palm Oil",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "2.99",
    mediumRiskMin: "3.00",
    mediumRiskMax: "7.99",
    lowRiskMin: "8.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Rubber",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "3.49",
    mediumRiskMin: "3.50",
    mediumRiskMax: "6.99",
    lowRiskMin: "7.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Tea",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "1.99",
    mediumRiskMin: "2.00",
    mediumRiskMax: "8.99",
    lowRiskMin: "9.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Banana",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "4.99",
    mediumRiskMin: "5.00",
    mediumRiskMax: "8.99",
    lowRiskMin: "9.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Grapes",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "2.99",
    mediumRiskMin: "3.00",
    mediumRiskMax: "7.99",
    lowRiskMin: "8.00",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Apples",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "3.99",
    mediumRiskMin: "4.00",
    mediumRiskMax: "7.49",
    lowRiskMin: "7.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Oranges",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "2.49",
    mediumRiskMin: "2.50",
    mediumRiskMax: "7.49",
    lowRiskMin: "7.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Mangoes",
    isDefaultValue: false,
    highRiskMin: "0.00",
    highRiskMax: "4.49",
    mediumRiskMin: "4.50",
    mediumRiskMax: "8.49",
    lowRiskMin: "8.50",
    lowRiskMax: "10.00",
  },
  {
    commodity: "Pineapples",
    isDefaultValue: true,
    highRiskMin: "0.00",
    highRiskMax: "1.99",
    mediumRiskMin: "3.00",
    mediumRiskMax: "7.99",
    lowRiskMin: "8.00",
    lowRiskMax: "10.00",
  },
];
